import { render } from "./lunarCalendar.vue?vue&type=template&id=4568854c"
import script from "./lunarCalendar.vue?vue&type=script&lang=js"
export * from "./lunarCalendar.vue?vue&type=script&lang=js"

import "./lunarCalendar.vue?vue&type=style&index=0&id=4568854c&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__